var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`a-loading-secondary ${_vm.loadingClass}`},[_c('p',[_vm._v("Cargando Datos...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }